import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export function BetaGate({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ loading: true });

  // Admin routes bypass the beta gate — admins authenticate via Google + the
  // ADMIN_EMAILS allowlist, so they shouldn't also need a beta code to reach
  // their dashboard (especially useful if the code is forgotten).
  const isAdminRoute = location.pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdminRoute) return;
    fetch("/api/beta/status", { credentials: "include" })
      .then(r => r.json())
      .then(data => setState({ loading: false, ...data }))
      // On network failure, assume gate is enabled and we're locked out —
      // the user can retry by entering a code (which will re-hit the server).
      .catch(() => setState({ loading: false, gate_enabled: true, authorized: false }));
  }, [isAdminRoute]);

  if (isAdminRoute) return children;

  if (state.loading) {
    return (
      <div style={{
        minHeight: "100vh", background: "#f8f7f4",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <div className="dots"><div className="dot" /><div className="dot" /><div className="dot" /></div>
      </div>
    );
  }

  if (!state.gate_enabled || state.authorized) return children;

  return <GateScreen onSuccess={() => setState({ loading: false, gate_enabled: true, authorized: true })} />;
}

function GateScreen({ onSuccess }) {
  const [code, setCode]             = useState("");
  const [error, setError]           = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setSubmitting(true); setError(null);
    try {
      const res = await fetch("/api/beta/redeem", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: code.trim() }),
      });
      const data = await res.json();
      if (data.error) setError(data.error);
      else onSuccess();
    } catch (err) {
      setError(err.message || "Couldn't verify code.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="gate">
      <div className="gate-inner">
        <h1 className="gate-title">Judge the Fit</h1>
        <p className="gate-sub">Private beta · enter your access code</p>
        <form onSubmit={submit}>
          <input
            className="gate-input"
            type="text"
            placeholder="ACCESS CODE"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            autoFocus
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            disabled={submitting}
          />
          <button className="gate-btn" type="submit" disabled={submitting || !code.trim()}>
            {submitting ? "Verifying…" : "Enter"}
          </button>
        </form>
        {error && <div className="gate-error">{error}</div>}
      </div>
    </div>
  );
}
